Core.TransportDocumentsRouter = Core.SubRouter.extend({
    routes: {
        'admin': 'adminTransportDocuments',
        'nvv': 'nvvTransportDocuments',
        'new': 'createTransportDocument',
        ':ids': 'viewTransportDocument',
        ':id/edit': 'editTransportDocument'
    },

    adminTransportDocuments: function() {
        var collection = new Core.TransportDocuments();
        var filterables = new Core.TransportDocumentFilterables();
        var view = new TransportDocumentsAdminView({
            collection: collection,
            filterables: filterables
        });
        app.setMainView(view);  
    },

    nvvTransportDocuments: function() {
        var selection = TransportDocumentNvv.getSelection();
        var completed = selection ? TransportDocumentNvv.onlyCompleted(selection) : [];
        if (completed.length === 0) {
            // No selection in the view state (for example after a reload): back to the list
            Backbone.history.navigate('transportdocuments/admin', { trigger: true, replace: true });
            return;
        }
        var view = new TransportDocumentNvvView({ selection: completed });
        app.setMainView(view);
    },

    createTransportDocument: function() {
        var jobId = Core.param('jobId');
        var wasteItemIds = Core.param('itemIds');

        $.ajax({
            type: 'GET',
            url: Core.contextRoot + '/transportdocument/template',
            data: {
                jobId: jobId,
                wasteItemIds: wasteItemIds
            },
            contentType: 'application/json',
            success: function(response) {
                var json = JSON.parse(response);
                if (json.id && TransportDocumentStatus.isLocked(json)) {
                    // the template returns the existing document when the items already belong to one, and it may be completed
                    errorResponse(i18next.t('transportDocument_locked_editBlocked'));
                    Backbone.history.navigate('transportdocuments/' + json.id, { trigger: true, replace: true });
                    return;
                }
                var model = new Core.TransportDocument(json);
                var view = new TransportDocumentView({ model: model, editing: true });
                app.setMainView(view);
            },
            error: function(response) {
                var message = i18next.t('transportDocument_loadFailed');
                if (response && response.status === 403) message = i18next.t('transportDocument_noPermission');
                else if (response && response.statusText) message += ': ' + response.statusText;
                errorResponse(message);
            }
        });
    },

    editTransportDocument: function(id) {
        var model = new Core.TransportDocument({ id: id });
        model.fetch({
            success: function() {
                if (TransportDocumentStatus.isLocked(model.toJSON())) {
                    errorResponse(i18next.t('transportDocument_locked_editBlocked'));
                    Backbone.history.navigate('transportdocuments/' + id, { trigger: true, replace: true });
                    return;
                }
                var view = new TransportDocumentView({ model: model, editing: true });
                app.setMainView(view);
            },
            error: function(model, response) {
                var message = i18next.t('transportDocument_loadFailed');
                if (response && response.status === 403) message = i18next.t('transportDocument_noPermission');
                else if (response && response.statusText) message += ': ' + response.statusText;
                errorResponse(message);
            }
        });
        return false;
    },

    viewTransportDocument: function(id) {
        var model = new Core.TransportDocument({ id: id });
        var view = new TransportDocumentView({ model: model });
        app.setMainView(view);
        return false;
    },
})